module.exports = __webpack_public_path__ + "assets/webgl/frames.108c115c.glb";